'use strict'

function initializeMapview() {
  $(document).ready(function(){
    //Click event for hero mobile navigation
    $('.mapview__form-group input').click(function() {
      let $url = $(this).val()
      $(this).parents('.mapview').find('iframe').attr('src', $url)
    });
  });
}

export default initializeMapview
